// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImgBox-module__ui-ImgBox--tpal1 {
  flex-shrink: 0;
}

.ImgBox-module__ui-ImgBox--tpal1 > img {
  display: block;
  width: 100%;
  height: auto;
}

.ImgBox-module__size-small--P8tq0 {
  width: 44px;
}

.ImgBox-module__size-medium--dC1p9 {
  width: 58px;
}

.ImgBox-module__size-large--N4Lla {
  width: 100px;
}

.ImgBox-module__size-x-large--EypA_ {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ImgBox/ImgBox.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ui-ImgBox {\n  flex-shrink: 0;\n}\n\n.ui-ImgBox > img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.size-small {\n  width: 44px;\n}\n\n.size-medium {\n  width: 58px;\n}\n\n.size-large {\n  width: 100px;\n}\n\n.size-x-large {\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-ImgBox": `ImgBox-module__ui-ImgBox--tpal1`,
	"size-small": `ImgBox-module__size-small--P8tq0`,
	"size-medium": `ImgBox-module__size-medium--dC1p9`,
	"size-large": `ImgBox-module__size-large--N4Lla`,
	"size-x-large": `ImgBox-module__size-x-large--EypA_`
};
export default ___CSS_LOADER_EXPORT___;
